import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  forwardRef,
  ChangeDetectorRef,
} from "@angular/core";
import { AlertController, PopoverController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { SpaceService } from "src/app/_services/space.service";
import { SelectButton } from "./select-buttons.model";
import { globalHelper } from "src/app/_helpers/global";
import { Observable } from "rxjs";
import { Utils } from "src/app/_helpers/utils";

@Component({
  selector: "app-select-buttons",
  templateUrl: "./select-buttons.component.html",
  styleUrls: ["./select-buttons.component.scss"],
  // providers: [
  //   {
  //     provide: NG_VALUE_ACCESSOR,
  //     useExisting: forwardRef(() => SelectButtonsComponent),
  //     multi: true,
  //   },
  // ],
})
export class SelectButtonsComponent implements OnInit {
  constructor(
    public alertController: AlertController,
    private translate: TranslateService,
    public spaceService: SpaceService,
    public popoverController: PopoverController,
    private changeDetectionRef: ChangeDetectorRef
  ) {}

  @Input()
  keyValueList: SelectButton[];

  @Input()
  selectedValue: number | string;

  @Input()
  defaultSelectedValue: number | string;

  @Input()
  disabled: boolean = false;

  @Input()
  multiple: boolean = false;

  @Input()
  outline: boolean = false;

  /** If true enable confirmation alert. Event will fire after succesfully accepted change. */
  @Input()
  confirmChange: boolean = false;

  @Input()
  customMessage: string;

  @Input()
  iconsList: any;

  @Input()
  disableValueZero = false;

  @Input()
  disableDeselect: boolean = false;

  @Input()
  whiteBackground: boolean = false;

  @Input() resetButtons: Observable<void>;

  @Input()
  icon: string;

  @Output()
  selectedChange: EventEmitter<any> = new EventEmitter<any>();

  selectedValueKey: string;
  multipleResultArray = [];

  ngOnInit(): void {
    this.resetButtons.subscribe(() => {
      this.selectedValue = this.defaultSelectedValue;
      this.changeDetectionRef.detectChanges();
    });

    if (this.iconsList !== undefined) {
      this.keyValueList.map((el) => {
        el.icon = this.iconsList.find((element) => element.value === el.value);
      });
    }
    this.selectKeyValue();
  }

  selectKeyValue() {
    if (this.keyValueList && this.keyValueList.length > 0) {
      if (
        !this.selectedValue ||
        !this.keyValueList.find((x) => x.value == this.selectedValue)
      ) {
        this.selectedValue = this.defaultSelectedValue;
      }
    }
  }

  async changeSelected(kv: SelectButton) {
    if (this.disabled) {
      this.onShowPopover();
      return;
    }

    // MULTIPLE SELECT
    if (this.multiple) {
      if (this.multipleResultArray.includes(kv.value)) {
        this.multipleResultArray.splice(
          this.multipleResultArray.indexOf(kv.value)
        );
      } else {
        this.multipleResultArray.push(kv.value);
      }
      this.multipleResultArray;

      this.selectedChange.emit(this.multipleResultArray);
    }
    // SINGLE SELECT
    else {
      if (this.selectedValue === kv.value) {
        this.selectedValue = null;
        this.selectedChange.emit(null);
        this.onChange(null);
        this.onTouched();
        return;
      }

      let previousValue = this.selectedValue;
      this.selectedValue = kv.value;

      if (this.confirmChange) {
        let mes;
        if (this.customMessage) {
          mes = this.customMessage + ' "' + kv.key + '"?';
        } else {
          mes =
            this.translate.instant("CONFIRMALERT.MESSAGE_TO") +
            ' "' +
            kv.key +
            '"?';
        }

        const alert = await this.alertController.create({
          header: this.translate.instant("CONFIRMALERT.TITLE"),
          message: mes,
          backdropDismiss: false,
          buttons: [
            {
              text: this.translate.instant("CONFIRMALERT.REJECT"),
              handler: () => {
                this.selectedValue = previousValue;
              },
            },
            {
              text: this.translate.instant("CONFIRMALERT.ACCEPT"),
              handler: () => {
                this.selectedChange.emit(kv.value);
                this.onChange(kv.value);
                this.onTouched();
              },
            },
          ],
        });

        await alert.present();
      } else {
        this.selectedChange.emit(kv.value);
        this.onChange(kv.value);
        this.onTouched();
      }
    }
  }

  _value = false;
  onChange: any = () => {};
  onTouched: any = () => {};

  buttonColor(value) {
    if (this.outline) {
      return "light";
    } else {
      if (this.multiple) {
        if (this.multipleResultArray.includes(value)) {
          return "secondary";
        } else {
          return "light";
        }
      } else if (this.selectedValue == value) {
        return "secondary";
      } else {
        return "light";
      }
    }
  }

  registerOnChange(fn) {
    this.onChange = fn;
  }

  writeValue(value) {
    if (value) {
      this.selectedValue = value;
    }
  }

  registerOnTouched(fn) {
    this.onTouched = fn;
  }
  disable(value): boolean {
    if (value === this.selectedValue) {
      return true;
    }
    if (value === 0 && this.disableValueZero && value !== this.selectedValue) {
      return true;
    }
  }

  disableZero(value): boolean {
    if (value === 0 && this.disableValueZero && value !== this.selectedValue) {
      return true;
    }
  }

  async onShowPopover() {
    let popoverInfo: string;

    popoverInfo = this.translate.instant("CONFIRMALERT.STATUS_CHANGE_ERROR");

    const popover = await globalHelper.Popover(
      this.popoverController,
      event,
      [],
      "user-assignment-view-share__popover",
      popoverInfo
    );
  }
}
